import { IRegistry } from '@cian/mf-registry/browser';
import { IMicrofrontendsAPI, IOpenAuthModalParameters } from 'shared/types/applicationContext';

const HEADER_MICROFRONTEND = 'header-frontend';
const OPEN_AUTH_MODAL_PATH = '/v3/open-auth-modal/';

export function createMicrofrontendsAPI(registry: IRegistry): IMicrofrontendsAPI {
  return {
    header: {
      async openAuthModal(parameters: IOpenAuthModalParameters): Promise<void> {
        const api = await registry.microfrontendStrict(HEADER_MICROFRONTEND).api()?.ensure();

        if (api) {
          await api.call(OPEN_AUTH_MODAL_PATH, parameters);
        }
      },
    },
  };
}
